module.exports = __webpack_public_path__ + "static/media/Pixel1.png?v=1c751ea2";